import { useState } from "react";
import { IS_LIVE } from "@/utils/constants";
import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import ConnectIntegration from "@/organisms/ConnectIntegration";
import IntegrationSection from "@/organisms/IntegrationSection";
import Discover from "@/organisms/Discover";
import Modal from "@/components/molecules/Modal";
import IntegrationForm from "@/components/molecules/IntegrationForm";
import Trustpilot from "@/organisms/Trustpilot";
import Script from "next/script";

export default function Integration() {
  const [showModal, setShowModal] = useState(false);

  const seoData = {
    indexing: true,
    title: "AnswerForce: Integrations to grow your business",
    description:
      "AnswerForce helps your business by capturing and pushing call data to your existing CRM platforms. Never miss a lead again thanks to our seamless integrations.",
    og: {
      title: "AnswerForce: Integrations to grow your business",
      description:
        "AnswerForce helps your business by capturing and pushing call data to your existing CRM platforms. Never miss a lead again thanks to our seamless integrations.",
      url: "https://www.answerforce.com/integrations",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/integrations-new-og.jpg",
    },
    twitter: {
      title: "AnswerForce: Integrations to grow your business",
      description:
        "AnswerForce helps your business by capturing and pushing call data to your existing CRM platforms. Never miss a lead again thanks to our seamless integrations.",
      url: "https://www.answerforce.com/integrations",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/integrations-new-og.jpg",
      image_alt: "AnswerForce integration page",
    },
  };

  const heroImgData = {
    fileName: "integration-hero",
    alt: "Powerful Integrations",
  };

  const hero = (
    <Hero
      heroTitle="Powerful <br />Integrations<span class='dot'>.</span>"
      heroContent="Link AnswerForce to your existing business software."
      heroImgData={heroImgData}
    />
  );

  const tileData = [
    {
      logo: {
        fileName: "housecallpro-logo",
      },
      title: "HousecallPro",
      content: "Automatically create a customer or job on your Housecall Pro.",
      href: "/integrations/housecallpro",
      hasTileTop: true,
      isLearnMore: true,
      isLargeTile: true,
    },
    {
      logo: {
        fileName: "servicetitan-logo",
      },
      title: "ServiceTitan",
      content: "Call and chat data added easily to your contacts.",
      href: "/integrations/servicetitan",
      hasTileTop: true,
      isLearnMore: true,
      isLargeTile: true,
    },
    {
      logo: {
        fileName: "pipedrive-logo",
      },
      title: "Pipedrive",
      content: "Manage leads and customer data from calls and chats.",
      href: "#",
      hasTileTop: true,
      isLearnMore: true,
      isLargeTile: true,
    },
  ];

  return (
    <Theme mainClassName="main" hasSidebar hero={hero} seo={seoData}>
      <ConnectIntegration
        title="Connect to the software you<br class='desktop-only'/> know and love"
        tileData={tileData}
      />
      <IntegrationSection />
      <Discover
        title="Can&#8217;t find <br class='phone-only'/>your preferred integration?"
        cta="Request a new integration"
        onClick={(e) => {
          e.preventDefault();
          document.body.classList.add("no-scroll");
          setShowModal(true);
        }}
      />
      {showModal && (
        <Modal
          hasCloseBtn={true}
          onClose={() => setShowModal(false)}
          show={showModal}
        >
          <IntegrationForm />
        </Modal>
      )}
      <Trustpilot title="In our customers&#8217; words" variant="carousel" />
      <Discover
        bgColor="white"
        title="Start your 24/7 answering service<span class='dot'>.</span>"
        color="black"
        cta="See Prices"
        href={
          IS_LIVE
            ? "https://www.answerforce.com/register"
            : "https://testing.answerforce.com/register"
        }
      />
      <Script
        strategy="beforeInteractive"
        src="https://storage.googleapis.com/clientaccess/registration/InputValidator.js"
      />
    </Theme>
  );
}
